export var IconSymbol;
(function (IconSymbol) {
    IconSymbol[IconSymbol["Add"] = 0] = "Add";
    IconSymbol[IconSymbol["Adsr"] = 1] = "Adsr";
    IconSymbol[IconSymbol["ArrayDown"] = 2] = "ArrayDown";
    IconSymbol[IconSymbol["AudioBus"] = 3] = "AudioBus";
    IconSymbol[IconSymbol["AudioDevice"] = 4] = "AudioDevice";
    IconSymbol[IconSymbol["AudioFile"] = 5] = "AudioFile";
    IconSymbol[IconSymbol["AutoGain"] = 6] = "AutoGain";
    IconSymbol[IconSymbol["Automation"] = 7] = "Automation";
    IconSymbol[IconSymbol["BassGuitar"] = 8] = "BassGuitar";
    IconSymbol[IconSymbol["Book"] = 9] = "Book";
    IconSymbol[IconSymbol["Box"] = 10] = "Box";
    IconSymbol[IconSymbol["Browse"] = 11] = "Browse";
    IconSymbol[IconSymbol["Maximizer"] = 12] = "Maximizer";
    IconSymbol[IconSymbol["Bug"] = 13] = "Bug";
    IconSymbol[IconSymbol["Fold"] = 14] = "Fold";
    IconSymbol[IconSymbol["Checkbox"] = 15] = "Checkbox";
    IconSymbol[IconSymbol["Clips"] = 16] = "Clips";
    IconSymbol[IconSymbol["Close"] = 17] = "Close";
    IconSymbol[IconSymbol["CloudFolder"] = 18] = "CloudFolder";
    IconSymbol[IconSymbol["CollapseDown"] = 19] = "CollapseDown";
    IconSymbol[IconSymbol["Compressor"] = 20] = "Compressor";
    IconSymbol[IconSymbol["Connected"] = 21] = "Connected";
    IconSymbol[IconSymbol["Cube"] = 22] = "Cube";
    IconSymbol[IconSymbol["Cursor"] = 23] = "Cursor";
    IconSymbol[IconSymbol["Curve"] = 24] = "Curve";
    IconSymbol[IconSymbol["Dattorro"] = 25] = "Dattorro";
    IconSymbol[IconSymbol["Delete"] = 26] = "Delete";
    IconSymbol[IconSymbol["Dial"] = 27] = "Dial";
    IconSymbol[IconSymbol["DinSlot"] = 28] = "DinSlot";
    IconSymbol[IconSymbol["Disconnected"] = 29] = "Disconnected";
    IconSymbol[IconSymbol["Divide"] = 30] = "Divide";
    IconSymbol[IconSymbol["DragConnections"] = 31] = "DragConnections";
    IconSymbol[IconSymbol["Dropdown"] = 32] = "Dropdown";
    IconSymbol[IconSymbol["Dropbox"] = 33] = "Dropbox";
    IconSymbol[IconSymbol["DrumSet"] = 34] = "DrumSet";
    IconSymbol[IconSymbol["Tidal"] = 35] = "Tidal";
    IconSymbol[IconSymbol["Duration"] = 36] = "Duration";
    IconSymbol[IconSymbol["EditBox"] = 37] = "EditBox";
    IconSymbol[IconSymbol["Effects"] = 38] = "Effects";
    IconSymbol[IconSymbol["Embed"] = 39] = "Embed";
    IconSymbol[IconSymbol["EQ"] = 40] = "EQ";
    IconSymbol[IconSymbol["Eraser"] = 41] = "Eraser";
    IconSymbol[IconSymbol["Exclude"] = 42] = "Exclude";
    IconSymbol[IconSymbol["Exit"] = 43] = "Exit";
    IconSymbol[IconSymbol["ExpandWidth"] = 44] = "ExpandWidth";
    IconSymbol[IconSymbol["FileList"] = 45] = "FileList";
    IconSymbol[IconSymbol["Film"] = 46] = "Film";
    IconSymbol[IconSymbol["Flask"] = 47] = "Flask";
    IconSymbol[IconSymbol["Focus"] = 48] = "Focus";
    IconSymbol[IconSymbol["Gate"] = 49] = "Gate";
    IconSymbol[IconSymbol["Generator"] = 50] = "Generator";
    IconSymbol[IconSymbol["GoogleDrive"] = 51] = "GoogleDrive";
    IconSymbol[IconSymbol["Groove"] = 52] = "Groove";
    IconSymbol[IconSymbol["Guitar"] = 53] = "Guitar";
    IconSymbol[IconSymbol["GuitarTab"] = 54] = "GuitarTab";
    IconSymbol[IconSymbol["Headphone"] = 55] = "Headphone";
    IconSymbol[IconSymbol["Heart"] = 56] = "Heart";
    IconSymbol[IconSymbol["Help"] = 57] = "Help";
    IconSymbol[IconSymbol["HighPass"] = 58] = "HighPass";
    IconSymbol[IconSymbol["HighShelf"] = 59] = "HighShelf";
    IconSymbol[IconSymbol["Insert"] = 60] = "Insert";
    IconSymbol[IconSymbol["Invert"] = 61] = "Invert";
    IconSymbol[IconSymbol["Info"] = 62] = "Info";
    IconSymbol[IconSymbol["Loop"] = 63] = "Loop";
    IconSymbol[IconSymbol["LowPass"] = 64] = "LowPass";
    IconSymbol[IconSymbol["LowShelf"] = 65] = "LowShelf";
    IconSymbol[IconSymbol["Magnet"] = 66] = "Magnet";
    IconSymbol[IconSymbol["MainMenu"] = 67] = "MainMenu";
    IconSymbol[IconSymbol["Maximized"] = 68] = "Maximized";
    IconSymbol[IconSymbol["Menu"] = 69] = "Menu";
    IconSymbol[IconSymbol["Merge"] = 70] = "Merge";
    IconSymbol[IconSymbol["Metronome"] = 71] = "Metronome";
    IconSymbol[IconSymbol["Microphone"] = 72] = "Microphone";
    IconSymbol[IconSymbol["Midi"] = 73] = "Midi";
    IconSymbol[IconSymbol["Minimized"] = 74] = "Minimized";
    IconSymbol[IconSymbol["Mix"] = 75] = "Mix";
    IconSymbol[IconSymbol["Mixing"] = 76] = "Mixing";
    IconSymbol[IconSymbol["Mute"] = 77] = "Mute";
    IconSymbol[IconSymbol["NanoWave"] = 78] = "NanoWave";
    IconSymbol[IconSymbol["NeuralAmp"] = 79] = "NeuralAmp";
    IconSymbol[IconSymbol["New"] = 80] = "New";
    IconSymbol[IconSymbol["NoAudio"] = 81] = "NoAudio";
    IconSymbol[IconSymbol["Note"] = 82] = "Note";
    IconSymbol[IconSymbol["NotePad"] = 83] = "NotePad";
    IconSymbol[IconSymbol["OpenDAW"] = 84] = "OpenDAW";
    IconSymbol[IconSymbol["Panel"] = 85] = "Panel";
    IconSymbol[IconSymbol["Peak"] = 86] = "Peak";
    IconSymbol[IconSymbol["Pencil"] = 87] = "Pencil";
    IconSymbol[IconSymbol["Piano"] = 88] = "Piano";
    IconSymbol[IconSymbol["Play"] = 89] = "Play";
    IconSymbol[IconSymbol["Playfield"] = 90] = "Playfield";
    IconSymbol[IconSymbol["PlayOnce"] = 91] = "PlayOnce";
    IconSymbol[IconSymbol["PlayRepeat"] = 92] = "PlayRepeat";
    IconSymbol[IconSymbol["PlayAlternate"] = 93] = "PlayAlternate";
    IconSymbol[IconSymbol["Pointer"] = 94] = "Pointer";
    IconSymbol[IconSymbol["Popout"] = 95] = "Popout";
    IconSymbol[IconSymbol["Primary"] = 96] = "Primary";
    IconSymbol[IconSymbol["Random"] = 97] = "Random";
    IconSymbol[IconSymbol["Record"] = 98] = "Record";
    IconSymbol[IconSymbol["Rectangle"] = 99] = "Rectangle";
    IconSymbol[IconSymbol["Redo"] = 100] = "Redo";
    IconSymbol[IconSymbol["Region"] = 101] = "Region";
    IconSymbol[IconSymbol["Robot"] = 102] = "Robot";
    IconSymbol[IconSymbol["RoundDown"] = 103] = "RoundDown";
    IconSymbol[IconSymbol["RoundUp"] = 104] = "RoundUp";
    IconSymbol[IconSymbol["Run"] = 105] = "Run";
    IconSymbol[IconSymbol["Sawtooth"] = 106] = "Sawtooth";
    IconSymbol[IconSymbol["Saxophone"] = 107] = "Saxophone";
    IconSymbol[IconSymbol["Scissors"] = 108] = "Scissors";
    IconSymbol[IconSymbol["Search"] = 109] = "Search";
    IconSymbol[IconSymbol["Shadertoy"] = 110] = "Shadertoy";
    IconSymbol[IconSymbol["Shutdown"] = 111] = "Shutdown";
    IconSymbol[IconSymbol["Sine"] = 112] = "Sine";
    IconSymbol[IconSymbol["Solo"] = 113] = "Solo";
    IconSymbol[IconSymbol["SoundFont"] = 114] = "SoundFont";
    IconSymbol[IconSymbol["Speaker"] = 115] = "Speaker";
    IconSymbol[IconSymbol["SpeakerHeadphone"] = 116] = "SpeakerHeadphone";
    IconSymbol[IconSymbol["Square"] = 117] = "Square";
    IconSymbol[IconSymbol["Stack"] = 118] = "Stack";
    IconSymbol[IconSymbol["Start"] = 119] = "Start";
    IconSymbol[IconSymbol["Stereo"] = 120] = "Stereo";
    IconSymbol[IconSymbol["Stop"] = 121] = "Stop";
    IconSymbol[IconSymbol["Subtract"] = 122] = "Subtract";
    IconSymbol[IconSymbol["Sun"] = 123] = "Sun";
    IconSymbol[IconSymbol["Swap"] = 124] = "Swap";
    IconSymbol[IconSymbol["System"] = 125] = "System";
    IconSymbol[IconSymbol["Table"] = 126] = "Table";
    IconSymbol[IconSymbol["Tape"] = 127] = "Tape";
    IconSymbol[IconSymbol["TapeReel"] = 128] = "TapeReel";
    IconSymbol[IconSymbol["Time"] = 129] = "Time";
    IconSymbol[IconSymbol["Timeline"] = 130] = "Timeline";
    IconSymbol[IconSymbol["Tool"] = 131] = "Tool";
    IconSymbol[IconSymbol["Triangle"] = 132] = "Triangle";
    IconSymbol[IconSymbol["Undo"] = 133] = "Undo";
    IconSymbol[IconSymbol["Unknown"] = 134] = "Unknown";
    IconSymbol[IconSymbol["UserFolder"] = 135] = "UserFolder";
    IconSymbol[IconSymbol["Velocity"] = 136] = "Velocity";
    IconSymbol[IconSymbol["Vinyl"] = 137] = "Vinyl";
    IconSymbol[IconSymbol["Volume"] = 138] = "Volume";
    IconSymbol[IconSymbol["VUMeter"] = 139] = "VUMeter";
    IconSymbol[IconSymbol["Waveform"] = 140] = "Waveform";
    IconSymbol[IconSymbol["Zeitgeist"] = 141] = "Zeitgeist";
})(IconSymbol || (IconSymbol = {}));
(function (IconSymbol) {
    IconSymbol.toName = (symbol) => IconSymbol[symbol];
    IconSymbol.fromName = (name) => IconSymbol[name] ?? IconSymbol.Rectangle;
})(IconSymbol || (IconSymbol = {}));
